import {until} from 'lit-html/directives/until';
import '../auth-context';
import '../dropdown';
import {
  jobTypesLabels,
  jobStatusLabels,
  jobStagesLabels,
  jobStatusDescriptions,
  inviteResultLabels,
  generalLabels, generalAriaLabels
} from '../i18n-labels';
import {jobStatuses, jobTypes, productLabels} from '../constants-enumerate';
import {UserJobs} from '../user-jobs';
import '../job-status-badge';

const renderJobTypeHeading = (ctx, html, job) => {
  if (job.job_type === jobTypes.LICENSING) {
    const product = job.meta_data?.aofl_product || job.params?.meta_data?.aofl_product || ''
    return html`${productLabels[product]} ${until(jobTypesLabels[job.job_type])}`;
  }

  return html`${until(jobTypesLabels[job.job_type])}`;
};

const renderJobStatusDescription = (ctx, html, job) => {
  if (job.job_type === jobTypes.LICENSING && job.status === jobStatuses.FAILED) {
    return html`${until(jobStatusDescriptions[job.status])}`;
  }

  return html`${until(jobStatusLabels[job.status])}`;
};

const failed = (job, ctx, html) => html`
  <div class="alert">
    <div class="d-flex justify-content-between pt-4">
      <h5 class="alert-heading">${renderJobTypeHeading(ctx, html, job)}</h5>
      <job-status-badge .status="${job.status}"></job-status-badge>
    </div>

    <p class="mb-0">${renderJobStatusDescription(ctx, html, job)} </p>
    ${job.$endDateTime}
  </div>
`;
const inProgress = (job, ctx, html) => html`
  <div class="alert">
    <div class="d-flex justify-content-between">
      <h5 class="alert-heading">${renderJobTypeHeading(ctx, html, job)} (${job.percentage}%)</h5>
      <job-status-badge .status="${job.status}"></job-status-badge>
    </div>

    <p class="mb-0">${until(jobStatusLabels[job.status])} ${until(jobStagesLabels[job.job_type][job.stage])}</p>
    ${job.$startTime}
  </div>
  `;

const done = (job, ctx, html) => html`
  <div class="alert">
    <div class="d-flex justify-content-between pt-4">
      <h5 class="alert-heading">${renderJobTypeHeading(ctx, html, job)} (${job.percentage}%)</h5>
      <job-status-badge .status="${job.status}"></job-status-badge>
    </div>

    <p>${until(jobStatusLabels[job.status])} ${until(jobStagesLabels[job.job_type][job.stage])}</p>
    ${renderJobDoneInfo(ctx, html, job)}
    ${job.$endDateTime}
  </div>
  `;

const renderJobDoneInfo = (ctx, html, job) => {
  if (
    job.job_type === jobTypes.EXPORT_SEARCH ||
    job.job_type === jobTypes.ROSTER_EXPORT ||
    job.job_type === jobTypes.DASHBOARD_CSV_EXPORT ||
    job.job_type === jobTypes.GENERATE_QR ||
    job.job_type === jobTypes.INVITES_PRINT
  ) {
    return html`<export-search-job tabIndex="0" class="btn btn-success btn-block cursor-pointer" .job="${job}">${until(generalLabels.download)} <span class="ai ai-download"></span></export-search-job>`;
  }

  if (
    (
      job.job_type === jobTypes.INVITES ||
      job.job_type === jobTypes.TEACHER_INVITES ||
      job.job_type === jobTypes.ADMIN_INVITES
    )
    &&
    Object.keys(job.result).length > 0
  ) {
    const templates = [];

    if (Object.keys(job.result.invites_sent_by_product).length) {
      Object.keys(job.result.invites_sent_by_product).forEach((product) => {
        templates.push(html`<div>${until(inviteResultLabels.productInvitesSent(productLabels[product]))}: ${job.result.invites_sent_by_product[product]}</div>`);
      });
    } else {
      templates.push(html`<div>${until(inviteResultLabels.sent)}: ${job.result.invites_sent}</div>`);
    }

    if (job.result.users_already_active) {
      templates.push(html`<div>${until(inviteResultLabels.usersAlreadyActive)}: ${job.result.users_already_active}</div>`);
    }

    if (job.result.invalid_emails) {
      templates.push(html`<div>${until(inviteResultLabels.invalidEmails)}: ${job.result.invalid_emails}</div>`);
    }

    if (job.result.skipped > 0) {
      templates.push(html`<div>${until(inviteResultLabels.skipped)}: ${job.result.skipped}</div>`);
    }

    if (job.result.skipped_due_to_test_email > 0) {
      templates.push(html`<div>${until(inviteResultLabels.skipped_due_to_test_email)}: ${job.result.skipped_due_to_test_email}</div>`);
    }

    return html`${templates}`;
  }
};


const canceled = (job, ctx, html) => html`
  <div class="alert">
    <div class="d-flex justify-content-between">
      <h5 class="alert-heading">${renderJobTypeHeading(ctx, html, job)}</h5>
      <job-status-badge .status="${job.status}"></job-status-badge>
    </div>

    <p class="mb-0">${until(jobStatusLabels[job.status])} ${until(jobStagesLabels[job.job_type][job.stage])}</p>
  </div>
`;


const getJobTemplate = (job, ctx, html) => {
  if (job.status === jobStatuses.FAILED) {
    return failed(job, ctx, html);
  } else if (job.status === jobStatuses.CANCELED) {
    return canceled(job, ctx, html);
  } else if (UserJobs.isDone(job)) {
    return done(job, ctx, html);
  }

  return inProgress(job, ctx, html);
};

export default (ctx, html) => html`
    ${ctx.jobs.length > 0 ? html`
      <div slot="dropdown-menu" class="dropdown-menu m-0 p-0" @click="${(e) => e.stopPropagation()}">
        ${ctx.jobs.map((job, index) => html`
          ${getJobTemplate(job, ctx, html)}
          ${index < ctx.jobs.length - 1 ? html`<hr>` : ''}
        `)}
      </div>
    ` : ''}
`;
